import { useState, useEffect } from 'react';

const useDeviceDetect = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        width: width,
        height: window.innerHeight
      });
      
      // 모바일: 768px 미만
      // 태블릿: 768px - 1024px  
      // 데스크톱: 1024px 이상
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
      
      console.log(`화면 감지 - 너비: ${width}px, 모바일: ${width < 768}, 태블릿: ${width >= 768 && width < 1024}, 데스크톱: ${width >= 1024}`);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop,
    screenSize
  };
};

export default useDeviceDetect;